/**
 * @name useCapitalize
 * @param Content {string} Example: 'hello world'
 * @returns {string} Example: 'Hello World'
 */

function useCapitalize(Content: string): string {
    const words = Content?.split(" ");
    const capitalizedWords = words?.map((word) => {
        return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
    });
    const NewContent = capitalizedWords?.join(" ");
    return NewContent;
}

export { useCapitalize };
